module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui simple large sidebar fixed vertical inverted labeled menu left"
  }, [_c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/booking",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v("\n    Booking Panel\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/reservations",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v("\n    Reservations\n  ")]), _vm._v(" "), (_vm.canSeeBoats) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/boats",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "ship icon"
  }), _vm._v("\n    Boats\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeUsers) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/users",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "users icon"
  }), _vm._v("\n    Users\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeReasons) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/reasons",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "question icon"
  }), _vm._v("\n    Reasons\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeServices) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/services",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "cocktail icon"
  }), _vm._v("\n    Services\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeVouchers) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/vouchers",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "barcode icon"
  }), _vm._v("\n    Vouchers\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeSettings) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/settings",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "edit icon"
  }), _vm._v("\n    Settings\n  ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/logout"
    }
  }, [_c('i', {
    staticClass: "sign out icon"
  }), _vm._v("\n    Logout\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a7bda28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Navigation.vue
// module id = 736
// module chunks = 1